// https://www.digi.com/resources/documentation/digidocs/90001488-13/reference/r_iso_8601_duration_format.htm
export function formatAsIso8601Duration(timeInMs: number) {
  return `PT${timeInMs / 1000}S`
}
